import { openDialog } from "./consent-manager/container.jsx";

class Glob {
  static instance = null;
  static trackingPreferences = {};

  constructor() {
    if (!Glob.instance) {
      Glob.instance = this;
      this.createGlobalObject();
    }
    return Glob.instance;
  }

  getTrackingPreferences() {
    return { ...Glob.trackingPreferences };
  }

  createGlobalObject() {
    Glob.globalObject = {};
    if (typeof window !== "undefined") {
      Glob.globalObject = window;
    }
    Glob.globalObject.consentManager = Glob.globalObject.consentManager || {};
  }

  enableOpenDialog() {
    Glob.globalObject.consentManager.openConsentManager = openDialog;
  }

  reset() {
    if (typeof window !== "undefined" && window.consentManager) {
      delete window.consentManager;
    }
    Glob.instance = null;
    Glob.globalObject = null;
    Glob.trackingPreferences = null;
    this.createGlobalObject();
  }

  setTrackingPreferences(trackingPreferencesInput) {
    Glob.trackingPreferences = trackingPreferencesInput;
  }

  enableConsentCategories() {
    Glob.globalObject.consentManager.getTrackingPreferences =
      Glob.globalObject.consentManager.getTrackingPreferences ||
      this.getTrackingPreferences.bind(this);
  }
}
const GlobInstance = new Glob();
export default GlobInstance;
